import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleAnalytics = defineConnector({
  identifier: "googleAnalytics",
  name: "Google Analytics",
  tagLine: "Web analytics service",
  keywords:
    "ga4 data api reports metrics dimensions properties sessions pageviews traffic",
  logo,
  protocol: "http",
  tags: ["data"],
  // Existing connectors still depend on this definition, so don’t delete it; new setups should use Google Cloud.
  unlisted: true,
  defaultUrlPattern: () => "https://analyticsdata\\.googleapis\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Set up Google Analytics API access",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Google Cloud Console](https://console.cloud.google.com/apis/credentials), create an OAuth 2.0 client or service account, and enable the **Google Analytics Data API**.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
          helperText:
            "A valid OAuth 2.0 access token or service account bearer token.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://analyticsdata.googleapis.com/v1beta/properties",
  },
});
